import { render, staticRenderFns } from "./ProgressTabs.vue?vue&type=template&id=c04af6a2"
import script from "./ProgressTabs.vue?vue&type=script&lang=js"
export * from "./ProgressTabs.vue?vue&type=script&lang=js"
import style0 from "./ProgressTabs.vue?vue&type=style&index=0&id=c04af6a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports